var map = {
	"./Icon1.svg": 7377,
	"./Icon2.svg": 1115,
	"./Icon3.svg": 4575,
	"./Icon4.svg": 398,
	"./Icon5.svg": 6843,
	"./Icon6.svg": 4735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9473;